<template>
  <v-container class="page">
    <div class="page-header pb-2">
      <v-btn @click="close()" icon color="blue darken-2">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>

    <div class="page-content">
      <v-btn color="blue darken-2" depressed dark @click="goNext" min-width="200"> Try again </v-btn>
      <v-btn color="grey" class="mt-4" depressed dark @click="close" min-width="200"> Take a break </v-btn>
    </div>
    <div class="mb-8"></div>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
export default {
  components: {
    //
  },
  computed: mapState({
    //
  }),
  props: [
    //
  ],
  data: () => ({
    autoplay: false,
    language: 1,
    timer: null,
  }),
  created() {
    //
  },
  mounted() {
    if (this.$route.query.lang) {
      this.language = this.$route.query.lang;
    }

    this.autoplay =
      this.$route.query.autoplay && this.$route.query.autoplay == 1
        ? true
        : false;

    this.timer = setTimeout(() => {
      this.isLoading = false;
    }, 1000);
  },
  beforeDestroy() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  },
  methods: {
    goPrevious() {
      this.$router.push({
        name: "ABCPage9",
        query: { autoplay: this.autoplay ? 1 : 0, lang: this.language },
      });
    },
    goNext() {
      this.$router.push({
        name: "ABCPage4",
        query: { autoplay: this.autoplay ? 1 : 0, lang: this.language, transition: "slide-right" },
      });
    },
    close() {
      this.$router.push({
        name: "ABCPage2",
      });
    },
  },
};
</script>

<style scoped>
.page-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.v-img-x {
  width: 100% !important;
  height: auto;
}
.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.page-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: #000 solid 1px;

  position: fixed;
  z-index: 99;
  bottom: 0;
  background-color: #fff;
  width: 100%;
  max-width: 480px;
}

.page {
  height: 100% !important;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: center;
  border: #000 solid 1px;
  background: rgb(255, 255, 255) !important;
}

.page-x {
  height: 100% !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  border: #000 solid 1px;
}

.buttons {
  display: flex;
}

.btn-dis {
  opacity: 0.5;
}

.vocab {
  text-decoration: underline;
  font-weight: 900;
}
</style>